import { createRoot } from "react-dom/client";
import "./globals.css";
import i18n from "./i18n";
import { App } from "./App";

function syncHtmlLang(lang: string) {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lang);
  }
}
syncHtmlLang(i18n.language || "en");
i18n.on("languageChanged", syncHtmlLang);

createRoot(document.getElementById("root")!).render(<App />);
